import { AllowedJobTypeList, type Metadata, type Prompt } from "@1js/pl-types";
import {
  DisplayCategoryKey,
  JobTypeKey,
  ProductNameKey,
} from "../PromptLibrary/PromptLibrary.data";
import type { Filter, FilterOption } from "./types";

/**
 * Group filter options by group key.
 */
export const groupFilters = (filter: Filter) => {
  return filter.options.reduce(
    (
      acc: {
        [group: string]: {
          value: string;
          group?: string;
        }[];
      },
      curr: {
        value: string;
        group?: string;
      }
    ) => {
      const group = curr.group ?? "NA";
      if (!acc[group]) {
        acc[group] = [];
      }
      acc[group].push(curr);
      return acc;
    },
    {}
  );
};

const convertMetadataToJobTypeFilters = (metadatas: Metadata[]) => {
  const uniqueJobTypeFilterTracker = new Set<string>();
  const metadataFilters: FilterOption[] = [];
  metadatas.forEach((item: Metadata) => {
    if (AllowedJobTypeList.has(item.Name)) {
      const key = `${item.Name}_${item.Value}`;
      if (!uniqueJobTypeFilterTracker.has(key)) {
        uniqueJobTypeFilterTracker.add(key);
        metadataFilters.push({
          value: item.Value,
          group: item.Name,
        });
      }
    }
  });

  return metadataFilters;
};

export const buildFilters = (prompts: Prompt[]): Filter[] => {
  if (!prompts || prompts.length === 0) {
    return [];
  }

  const displayCategories: string[] = [];
  let productNames: string[] = [];
  let metadatas: Metadata[] = [];

  prompts.forEach((p) => {
    if (p.Origin !== "User") {
      displayCategories.push(p.DisplayCategory.toString());
    }
    productNames = [...productNames, ...p.Products];

    if (p.Metadata) {
      metadatas = [...metadatas, ...p.Metadata];
    }
  });

  return [
    {
      key: ProductNameKey,
      options: [...new Set(productNames)].map((x) => {
        return { value: x };
      }),
      type: "dropdown",
    },
    {
      key: DisplayCategoryKey,
      options: [...new Set(displayCategories)].map((x) => {
        return { value: x };
      }),
      type: "dropdown",
    },
    {
      key: JobTypeKey,
      options: convertMetadataToJobTypeFilters(metadatas),
      type: "dropdown",
    },
  ];
};
